// steps/OrderKindStep.tsx

import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Truck, ArrowLeft, Mountain, Warehouse, History } from "lucide-react";

import { useAllowScroll } from "../AllowScrollContext";
import { ActionItem } from "@/shared/sharedService/ActionItem";

export type OrderKind = "MATERIAL" | "BAUHOF" | "SITE_WORK" | "HISTORY";

export default function OrderKindStep({
  value,
  onChange,
  canGoBack = false,
  onBack,
}: {
  value: OrderKind | null;
  onChange: (kind: OrderKind) => void;
  canGoBack?: boolean;
  onBack?: () => void;
}) {
  const { setAllowScroll } = useAllowScroll();

  useEffect(() => {
    setAllowScroll(false);
  }, []);

  return (
    <Box>
      <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ fontSize: 18 }}>Was soll bestellt werden?</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >
        {canGoBack && onBack ? <ActionItem icon={ArrowLeft} label="zurück" color={undefined} onPress={onBack} /> : null}

        <ActionItem icon={Mountain} big label="Material" sublabel="Schüttgut, Mischgut etc." color="blue" onPress={() => onChange("MATERIAL")} />
        <ActionItem icon={Warehouse} big label="Bauhof" sublabel="Werkzeug, Ausrüstung etc." color="orange" onPress={() => onChange("BAUHOF")} />
        <ActionItem icon={Truck} big label="Nur LKW" sublabel="Baustellendienst" color="green" onPress={() => onChange("SITE_WORK")} />
        <ActionItem icon={History} label="Vergangene Bestellung kopieren" color={undefined} onPress={() => onChange("HISTORY")} />
      </Box>
    </Box>
  );
}
